import { Text, View } from "react-native";
import Pagination from "ui/molecules/pagination/Pagination";
import { useUrgentConcernsWithOffline } from "app/features/offline/hooks/useUrgentConcernsWithOffline";
import { getStatusTextColorClass } from "ui/utils/statusColorMap";
import { NoItemsComponent } from "ui/atoms/noItems";
import { UrgentConcernStatusEnum } from "app/services/api/types/shiftHandover/enums/UrgentConcernStatusEnum";
import {
  formatTimestamp,
  UrgentConcernRecord,
} from "../molecules/UrgentConcernRecord";

export { formatTimestamp };

interface Props {
  status: UrgentConcernStatusEnum;
  title: string;
}

export function UrgentConcernsTable({ status, title }: Props) {
  const { data, meta, handlePageChange, isFetching } =
    useUrgentConcernsWithOffline({ status });

  return (
    <View>
      <Text
        className={`${getStatusTextColorClass(status)} font-semibold text-base mb-2`}
      >
        {title}
      </Text>
      <View className="border rounded-lg border-border-200 bg-white p-2 mb-3">
        <UrgentConcernRecord
          data={data ?? []}
          status={status}
          isFetching={isFetching}
          noDataMessage={
            <NoItemsComponent
              title={`No ${title.toLowerCase()}`}
              subtitle={`There are no ${title.toLowerCase()} urgent concerns`}
            />
          }
        />
      </View>
      {data?.length ? (
        <Pagination meta={meta} onPageChange={handlePageChange} />
      ) : null}
    </View>
  );
}
